// Menú móvil: Escape cierra y devuelve el foco.
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const drawer = document.querySelector('.drawer[open]');
  if (!drawer) return;
  drawer.removeAttribute('open');
  drawer.querySelector('summary').focus();
});

// Variantes de producto: actualiza id, precio y disponibilidad sin recargar.
document.querySelectorAll('[data-product-form]').forEach((form) => {
  const select = form.querySelector('[data-variant-select]');
  const data = form.querySelector('[data-variants]');
  if (!select || !data) return;
  const variants = JSON.parse(data.textContent);
  const buttons = document.querySelectorAll(`[data-add]`);
  const prices = document.querySelectorAll('[data-product-price]');
  select.addEventListener('change', () => {
    const variant = variants.find((item) => String(item.id) === select.value);
    if (!variant) return;
    buttons.forEach((button) => {
      button.disabled = !variant.available;
      const label = button.querySelector('[data-add-label]');
      if (label) label.textContent = variant.available ? button.dataset.addText : button.dataset.soldText;
    });
    prices.forEach((price) => { price.textContent = variant.price; });
  });
});

// Galería de producto: la miniatura elegida muestra su imagen.
document.querySelectorAll('[data-gallery]').forEach((gallery) => {
  gallery.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-thumb]');
    if (!thumb) return;
    gallery.querySelectorAll('[data-slide]').forEach((slide) => {
      slide.classList.toggle('is-active', slide.dataset.slide === thumb.dataset.thumb);
    });
    gallery.querySelectorAll('[data-thumb]').forEach((item) => item.removeAttribute('aria-current'));
    thumb.setAttribute('aria-current', 'true');
  });
});

// Barra de compra móvil: aparece solo después de pasar el bloque principal.
const buyBlock = document.querySelector('[data-buy-block]');
const buyBar = document.querySelector('[data-buybar]');
if (buyBlock && buyBar && 'IntersectionObserver' in window) {
  new IntersectionObserver(([entry]) => {
    const passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
    buyBar.hidden = !passed;
    document.body.classList.toggle('has-buybar', passed);
  }).observe(buyBlock);
}

// Estado de carga mientras se envía un formulario de compra.
document.addEventListener('submit', (event) => {
  const button = event.submitter || event.target.querySelector('[data-add], [name="checkout"]');
  if (!button) return;
  button.classList.add('is-loading');
  button.setAttribute('aria-busy', 'true');
});

// Orden en colecciones: sin botón cuando hay JS.
document.querySelectorAll('[data-sort]').forEach((select) => {
  select.addEventListener('change', () => select.form.submit());
});

// Entrada de secciones (450 ms). Nada depende de ella: sin JS o con movimiento reducido todo se ve.
const reveals = document.querySelectorAll('.reveal');
if (window.Shopify && Shopify.designMode) {
  reveals.forEach((element) => element.classList.add('is-visible'));
} else if ('IntersectionObserver' in window) {
  let observerRan = false;
  const observer = new IntersectionObserver((entries) => {
    observerRan = true;
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -5% 0px' });
  reveals.forEach((element) => observer.observe(element));
  // Respaldo: el contenido nunca depende de que se dispare el efecto.
  setTimeout(() => {
    if (!observerRan) reveals.forEach((element) => element.classList.add('is-visible'));
  }, 2500);
} else {
  reveals.forEach((element) => element.classList.add('is-visible'));
}
